import React from 'react'
import { DirectoryDropdown, CommunityDropdown } from './'
import { useLocation } from '@reach/router'
import BeyondDropdown from './BeyondDropdown'

const MobileDropdown = () => {
	const location = useLocation()
	const isHomePage =
		location?.pathname === '/' ||
		location?.pathname === '/business' ||
		location?.pathname === '/being'||
		location?.pathname === '/bloomseason/' ||
		location?.pathname === '/bloomseason/business' ||
		location?.pathname === '/bloomseason/being' 
		

	const isCommunity = location?.pathname.includes('/community');
	const isBeyond = location?.pathname.includes('/beyond');

	if (isHomePage) return <DirectoryDropdown />
	if (isCommunity) return <CommunityDropdown />
	if (isBeyond) return <BeyondDropdown/>
	return null
}

export default MobileDropdown
